import React from "react";

const SectionDateRangeSkeleton = () => {
  return (
    <div className="listingSection__wrap overflow-hidden">
      {/* Header Skeleton */}
      <h2
        className="text-2xl font-semibold bg-gray-300 rounded-md w-36 h-6 mb-2 animate-pulse"
        aria-hidden="true"
      ></h2>
      <span className="sr-only">Loading section title...</span> {/* Accessible content */}
      <span
        className="block mt-2 bg-gray-300 h-4 w-52 rounded-md animate-pulse"
        aria-hidden="true"
      ></span>


      {/* Datepicker Skeleton */}
      <div className="grid grid-cols-2 gap-4">
        {/* Skeleton for the first month view */}
        <div className="p-2">
          <div
            className="bg-gray-300 h-5 w-full rounded-md mb-3 animate-pulse"
            aria-hidden="true"
          ></div>
          <span className="sr-only"></span> {/* Accessible content */}
          <div className="grid grid-cols-7 gap-1">
            {[...Array(35)].map((_, i) => (
              <div
                key={i}
                className="bg-gray-300 h-8 w-8 rounded-md animate-pulse"
                aria-hidden="true"
              ></div>
            ))}
          </div>
        </div>

        {/* Skeleton for the second month view */}
        <div className="p-2">
          <div
            className="bg-gray-300 h-5 w-full rounded-md mb-3 animate-pulse"
            aria-hidden="true"
          ></div>
          <span className="sr-only"></span> {/* Accessible content */}
          <div className="grid grid-cols-7 gap-1">
            {[...Array(35)].map((_, i) => (
              <div
                key={i}
                className="bg-gray-300 h-8 w-8 rounded-md animate-pulse"
                aria-hidden="true"
              ></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionDateRangeSkeleton;